import React from "react";
import { references } from "../mock";

export default function Marquee() {
  const items = [...references, ...references];
  return (
    <div className="relative overflow-hidden" data-testid="reference-marquee">
      <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-brand-paper to-transparent z-10" />
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-brand-paper to-transparent z-10" />
      <div className="flex w-max animate-marquee">
        {items.map((r, i) => (
          <div key={i} className="flex-shrink-0 w-44 h-24 flex items-center justify-center px-8 border-r border-brand-line">
            <img
              src={r.image}
              alt="Referans"
              loading="lazy"
              className="max-h-12 max-w-full object-contain grayscale opacity-45 hover:opacity-100 hover:grayscale-0 transition-[opacity,filter] duration-500"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
